import { Product } from "@/data/data";
import React from "react";
interface DescriptionContentProps {
  itemData: Product[];
}
function DescriptionContent({ itemData }: DescriptionContentProps) {
  return (
    <>
      {itemData.map((item, index) => (
        <div key={index} className="w-full rounded-2xl space-y-2.5">
          {item.description ? (
            <h3 className="flex items-center justify-between w-full px-4 py-2 font-medium text-left bg-slate-100/80 hover:bg-slate-200/60 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-slate-500 focus-visible:ring-opacity-75 ">
              {item.description}
            </h3>
          ) : (
            ""
          )}
        </div>
      ))}
    </>
  );
}

export default DescriptionContent;
